import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, startWith, debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SearchService {

    // TODO(NR): URLs and API
    baseUrl: string = '/search/';
    queryUrl: string = '?searchTerm=';

    constructor(private http: HttpClient) { }

    search(terms: Observable<string>) {
        // TODO(NR): expensive call to a backend, switchMap could be used — when a new search is made, pending results are no longer needed
        // return terms.pipe(debounceTime(400),
        //   distinctUntilChanged(),
        //   switchMap(term => this.searchEntries(term)));
    }

    searchEntries(term) {
        // TODO(NR): hook up real service
        // return this.http
        //   .get(this.baseUrl + this.queryUrl + term)
        //   .pipe(map(res => res.results || []));
    }
}
